<template>
  <v-dialog v-model="dialog" width="600">
    <v-card>
      <gg-toolbar @close="close">
        View/Download SSH key
      </gg-toolbar>

      <v-card-text class="text-center">
        <template v-if="!loading">
          <p class="text-left">{{ keyDescription }}</p>
          <v-textarea
            outlined
            :value="sshKeyText"
            hide-details
            readonly
            no-resize
            rows="8"
          />
        </template>
        <v-progress-circular
          v-else
          indeterminate
          color="primary"
          size="64"
        />
      </v-card-text>
      <v-card-actions class="justify-content-end pb-3">
        <gg-btn secondary @click="close">Cancel</gg-btn>
        <gg-btn @click="copy" :disabled="loading">Copy to Clipboard</gg-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import modalMixin from '@/mixins/modal'

export default {
  name: 'ViewSshKeyModal',
  mixins: [modalMixin],
  props: {
    sshKey: {
      type: Object,
      required: true
    },
    pub: {
      type: [String, Number],
      required: true
    },
  },
  data () {
    return {
      loading: false,
      sshKeyText: '',
    }
  },
  computed: {
    keyDescription () {
      return this.pub == '1'
        ? `Public SSH Key “${this.sshKey.name}” Open Key`
        : `Private SSH Key “${this.sshKey.name}” Open Key`
    },
  },
  methods: {
    ...mapActions(['getHostingSshKey', 'reportSuccess', 'reportError']),
    copy () {
      navigator.clipboard.writeText(this.sshKeyText)
      this.reportSuccess('SSH key copied.')
    }
  },
  async created () {
    this.loading = true
    try {
      const data = await this.getHostingSshKey({
        pub: this.pub,
        name: this.sshKey.name,
        _username: this.$route.query.user,
      })
      this.sshKeyText = data[0].key
    } catch (e) {
      this.reportError(e)
    } finally {
      this.loading = false
    }
  },
}
</script>
